export const emailRegex = () => {
  return /^(?!.*\.{2,})(?!.*\.$)(?!^\.)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+([.]?[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-zA-Z0-9-_]+\.)+[a-zA-Z0-9]{1,}$/;
};
